import { useState } from 'react';
import { categories, stats } from '@/mocks/homeContent';
import type { Category } from '@/mocks/homeContent';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function Sections() {
  const [tab, setTab] = useState<'hot' | 'cats'>('hot');
  const [liked, setLiked] = useState<number[]>([]);

  const toggleLike = (id: number) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const hotPosts = [
    { id: 1, rank: 1, title: '热播剧大结局冲上热搜，网友直呼反转太狠', heat: '286万', up: true },
    { id: 2, rank: 2, title: '老牌综艺回归首播，弹幕一秒破万', heat: '241万', up: true },
    { id: 3, rank: 3, title: '顶流歌手新单曲上线，评论区现场炸了', heat: '198万', up: true },
    { id: 4, rank: 4, title: '直播带货翻车名场面盘点，瓜友笑不活了', heat: '167万', up: true },
    { id: 5, rank: 5, title: '一夜爆红的网络热梗，原来是这么来的', heat: '142万', up: true },
  ];

  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-2">
              <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Trending Now</span>
              <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">今日热榜</h2>
              <p className="mt-1 text-sm leading-relaxed text-foreground-700">
                实时汇总瓜友最关心的新鲜话题，一键切换看看大家都在追什么。
              </p>
            </div>

            <div className="mt-6 flex items-center gap-2 rounded-full border border-background-200 bg-background-50 p-1">
              {(['hot', 'cats'] as const).map((t) => (
                <button
                  key={t}
                  onClick={() => setTab(t)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                    tab === t ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-primary-700'
                  }`}
                >
                  {t === 'hot' ? '🔥 热度飙升' : '🗂 栏目分类'}
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8">
            {tab === 'hot' ? (
              <div className="flex flex-col gap-3">
                {hotPosts.map((p) => (
                  <div
                    key={p.id}
                    className="flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-200 hover:bg-background-100 md:p-4"
                  >
                    <span
                      className={`font-heading w-8 shrink-0 text-center text-2xl ${
                        p.rank <= 3 ? 'text-primary-500' : 'text-foreground-400'
                      }`}
                    >
                      {p.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h4 className="truncate text-sm font-bold text-foreground-950 md:text-base">{p.title}</h4>
                      <p className="text-xs text-foreground-600">热度 {p.heat} {p.up ? '↑ 上升中' : '↓'}</p>
                    </div>
                    <button
                      onClick={() => toggleLike(p.id)}
                      aria-label="点赞"
                      className={`flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors ${
                        liked.includes(p.id) ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600 hover:text-primary-500'
                      }`}
                    >
                      <i className={`${liked.includes(p.id) ? 'ri-heart-3-fill' : 'ri-heart-3-line'} text-lg`}></i>
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {categories.map((c) => (
                  <div key={c.slug} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${colorMap[c.color]}`}>
                      <i className={`${c.icon} text-xl`}></i>
                    </span>
                    <div className="min-w-0">
                      <h4 className="text-sm font-bold text-foreground-950">{c.name}</h4>
                      <p className="truncate text-xs text-foreground-600">{c.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50 p-5 text-center border border-background-200">
              <p className="font-heading text-3xl text-primary-500">{s.value}</p>
              <p className="mt-1 text-sm text-foreground-700">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}